import { validateVal } from "./numberMethods";
export var summarizeType;
(function (summarizeType) {
    summarizeType["K"] = "K";
    summarizeType["LAKHS"] = "L";
    summarizeType["CR"] = "Cr";
})(summarizeType || (summarizeType = {}));
export function summarizeWithType(val, type, typeView = true) {
    if (!validateVal(val === null || val === void 0 ? void 0 : val.valueOf())) {
        const negative = Number(val) < 0;
        val = Math.abs(Number(val));
        if (type === summarizeType.K) {
            let result = Math.round(Number(val) / 10) / 100;
            val = typeView ? result + "K" : result;
        }
        else if (type === summarizeType.LAKHS) {
            let result = Math.round(Number(val) / 1000) / 100;
            val = typeView ? result + "L" : result;
        }
        else if (type === summarizeType.CR) {
            let result = Math.round(Number(val) / 100000) / 100;
            val = typeView ? result + "Cr" : result;
        }
        return negative ? "-" + val : val;
    }
    else {
        return "--";
    }
}
